<primary-text-button [noLeftPadding]="noLeftPadding"
                     [noRightMargin]="noRightMargin"
                     [selected]="selected"
                     [disabled]="disabled"
                     (onClick)="onClick.emit()"
                     [buttonClass]="'text-button--cancelary'">
    <ng-content></ng-content>
</primary-text-button>